export default {
	NoData: 'No data in options field for displaying as multiple checkbox',
	Delete: 'Delete',
	AddOne: 'Add One',
};
